import React, { createContext, useContext, useEffect, useState } from 'react';
import client from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem('aaarya_user');
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password, role) => {
    setLoading(true);
    try {
      const { data } = await client.post('/auth/login', { email, password, role });
      localStorage.setItem('aaarya_token', data.token);
      localStorage.setItem('aaarya_user', JSON.stringify(data));
      setUser(data);
      return data;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('aaarya_token');
    localStorage.removeItem('aaarya_user');
    setUser(null);
  };

  // On mount, if we have a token try to refresh user from /auth/me
  useEffect(() => {
    const token = localStorage.getItem('aaarya_token');
    if (!token || !user) return;
    client.get('/auth/me').catch(() => logout());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
